import { COMPLIANCE_NOTE, CTAS } from '../content/site';
import { VERSION } from '../version';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-line bg-surface-alt">
      <div className="container-content py-12">
        <div className="grid gap-8 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <p className="font-heading text-lg font-bold text-ink-900">
              Corporate <span className="text-aurora">Partnerships</span>
            </p>
            <p className="mt-3 max-w-sm text-sm text-ink-500">
              Turn real products into measurable, skill-based prize campaigns on the
              My Investments Prizes platform.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-sm font-semibold uppercase tracking-wider text-ink-700">
              Get started
            </h2>
            <ul className="mt-3 space-y-2 text-sm">
              <li><a className="text-ink-500 hover:text-primary-700" href={CTAS.sponsorPrize.href}>{CTAS.sponsorPrize.label}</a></li>
              <li><a className="text-ink-500 hover:text-primary-700" href={CTAS.bookCall.href}>{CTAS.bookCall.label}</a></li>
              <li><a className="text-ink-500 hover:text-primary-700" href={CTAS.requestPack.href}>{CTAS.requestPack.label}</a></li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-semibold uppercase tracking-wider text-ink-700">
              Explore
            </h2>
            <ul className="mt-3 space-y-2 text-sm">
              <li><a className="text-ink-500 hover:text-primary-700" href="#partnership-types">Partnership types</a></li>
              <li><a className="text-ink-500 hover:text-primary-700" href="#benefits">Benefits</a></li>
              <li><a className="text-ink-500 hover:text-primary-700" href="#examples">Campaign examples</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-line pt-6">
          <p className="max-w-3xl text-xs leading-relaxed text-ink-500">{COMPLIANCE_NOTE}</p>
          <p className="mt-4 text-xs text-ink-500">
            &copy; {year} My Investments. All rights reserved. &middot; v{VERSION}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
